import Cookies from "js-cookie";

// Business profile has NO equivalent act in the existing PHP backend yet
// (getBusinessInfo / updateBusinessInfo / file upload). Until those acts are added
// to PHP, provide a graceful stub: READ-ONLY best-effort from the stored login
// session, and make writes surface a clear "not yet available" error (instead of
// silently hitting the dead localhost:3001 backend).  See docs/HOSTESS_APP_PHP_ADAPTATION_SCAN.md.

const NOT_SUPPORTED = "Business profile editing is not yet available on the server backend.";

function sessionBusiness() {
    try {
        const raw = Cookies.get("userData");
        const data = raw ? JSON.parse(raw) : null;
        return (data && Array.isArray(data.business) && data.business[0]) || null;
    } catch {
        return null;
    }
}

async function getBusinessInfo() {
    const b = sessionBusiness();
    if (!b) return null;
    const name = (Array.isArray(b.names) && b.names[0] && b.names[0].name) || "";
    return {
        name,
        description: "",
        phone: b.businessesPhone || "",
        location: [b.businessesAddress, b.businessCity].filter(Boolean).join(", "),
        website: "",
        social_facebook: "",
        social_instagram: "",
        banner_image: "",
        menu_file: "",
        tags: "",
    };
}

async function updateBusinessInfo() {
    console.warn(NOT_SUPPORTED);
    throw new Error(NOT_SUPPORTED);
}

async function uploadFile() {
    console.warn(NOT_SUPPORTED);
    throw new Error(NOT_SUPPORTED);
}

export default { getBusinessInfo, updateBusinessInfo, uploadFile };
